import { useState } from 'react';

import CancelMembership from './CancelMembership';
import HoldMembership from './HoldMembership';
// eslint-disable-next-line import/no-cycle
import AddHoldModal from './components/AddHoldModal';
import CancelClubMembershipModal from './components/CancelClubMembershipModal';
import CancelMessage from './components/CancelMessage';
import DeleteHoldModal from './components/DeleteHoldModal';
import EditHoldModal from './components/EditHoldModal';
import HoldMessage from './components/HoldMessage';
import SkipSubscriptionShipment from './subscription/SkipShipment';
import SkipSubscriptionShipmentModal from './subscription/SkipShipmentModal';
import UnskipSubscriptionShipmentModal from './subscription/UnskipShipmentModal';
import SkipTraditionalShipment from './traditional/SkipShipment';
import SkipTraditionalShipmentModal from './traditional/SkipShipmentModal';
import UnskipTraditionalShipmentModal from './traditional/UnskipShipmentModal';

const HoldCancelClubMembership = (props) => {
  const { clubMembership, clubMemberShipment, clubSubscriptionShipment } =
    props;

  const [modal, setModal] = useState(null);
  const [holdId, setHoldId] = useState(null);

  const onModal = (modalName, id) => {
    setHoldId(id);
    setModal(modalName);
  };

  const onCloseModal = () => {
    setHoldId(null);
    setModal(null);
  };

  if (clubMemberShipment) {
    return (
      <>
        <div className="c7-account-row c7-account-row--basic" />
        <CancelMessage clubMembership={clubMembership} />
        <HoldMessage clubMembership={clubMembership} />
        <div className="c7-club-actions c7-club-actions--hold-cancel">
          <SkipTraditionalShipment
            clubMemberShipment={clubMemberShipment}
            onModal={onModal}
          />
          <CancelMembership clubMembership={clubMembership} onModal={onModal} />
        </div>
        <Modal
          modal={modal}
          object={{ clubMembership, clubMemberShipment, holdId, onCloseModal }}
        />
      </>
    );
  }
  if (clubSubscriptionShipment) {
    return (
      <>
        <div className="c7-account-row c7-account-row--basic" />
        <CancelMessage clubMembership={clubMembership} />
        <HoldMessage clubMembership={clubMembership} />
        <div className="c7-club-actions c7-club-actions--hold-cancel">
          <SkipSubscriptionShipment
            clubSubscriptionShipment={clubSubscriptionShipment}
            onModal={onModal}
          />
          <CancelMembership clubMembership={clubMembership} onModal={onModal} />
        </div>
        <Modal
          modal={modal}
          object={{
            clubMembership,
            clubSubscriptionShipment,
            holdId,
            onCloseModal
          }}
        />
      </>
    );
  }
  return (
    <>
      <div className="c7-account-row c7-account-row--basic" />
      <CancelMessage clubMembership={clubMembership} />
      <HoldMessage clubMembership={clubMembership} />
      <div className="c7-club-actions c7-club-actions--hold-cancel">
        <HoldMembership clubMembership={clubMembership} onModal={onModal} />
        <CancelMembership clubMembership={clubMembership} onModal={onModal} />
      </div>
      <Modal modal={modal} object={{ clubMembership, holdId, onCloseModal }} />
    </>
  );
};

const Modal = (props) => {
  const { modal, object } = props;
  const {
    clubMembership,
    holdId,
    onCloseModal,
    clubMemberShipment,
    clubSubscriptionShipment
  } = object;
  switch (modal) {
    case 'cancel': {
      return (
        <CancelClubMembershipModal
          onCloseModal={onCloseModal}
          clubMembershipId={clubMembership.id}
        />
      );
    }
    case 'addHold': {
      return (
        <AddHoldModal
          onCloseModal={onCloseModal}
          clubMembershipId={clubMembership.id}
        />
      );
    }
    case 'editHold': {
      return (
        <EditHoldModal
          holdId={holdId}
          onCloseModal={onCloseModal}
          clubMembershipId={clubMembership.id}
        />
      );
    }
    case 'deleteHold': {
      return (
        <DeleteHoldModal
          holdId={holdId}
          onCloseModal={onCloseModal}
          clubMembershipId={clubMembership.id}
        />
      );
    }
    case 'skipTraditionalShipment': {
      return (
        <SkipTraditionalShipmentModal
          onCloseModal={onCloseModal}
          clubMemberShipmentId={clubMemberShipment.id}
        />
      );
    }
    case 'unskipTraditionalShipment': {
      return (
        <UnskipTraditionalShipmentModal
          onCloseModal={onCloseModal}
          clubMemberShipmentId={clubMemberShipment.id}
        />
      );
    }
    case 'skipSubscriptionShipment': {
      return (
        <SkipSubscriptionShipmentModal
          onCloseModal={onCloseModal}
          clubSubscriptionShipmentId={clubSubscriptionShipment.id}
        />
      );
    }
    case 'unskipSubscriptionShipment': {
      return (
        <UnskipSubscriptionShipmentModal
          onCloseModal={onCloseModal}
          clubSubscriptionShipmentId={clubSubscriptionShipment.id}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default HoldCancelClubMembership;
